/**
 * Pré-carregamento das áreas (SPEC-v2 2.4, 9.2): cada área é um chunk; a vizinha desce em ócio, só
 * no desktop e sem `Save-Data`. O login baixa a área de destino quando o campo de senha recebe foco.
 */
import type { Area } from '@rota/contracts';

const loaders: Record<Area, () => Promise<unknown>> = {
  painel: () => import('@/areas/painel/PainelArea'),
  automacoes: () => import('@/areas/automacoes/AutomacoesArea'),
  estudio: () => import('@/areas/estudio/EstudioArea'),
  palco: () => import('@/areas/palco/PalcoArea'),
};

const started = new Set<Area>();

export function preloadArea(area: Area): void {
  if (started.has(area)) return;
  started.add(area);
  void loaders[area]().catch(() => started.delete(area));
}

function saveData(): boolean {
  const c = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection;
  return c?.saveData === true;
}

/** Áreas vizinhas em ócio (desktop, sem economia de dados). */
export function preloadNeighborsWhenIdle(current: Area, allowed: readonly Area[]): void {
  if (typeof window === 'undefined' || saveData()) return;
  if (!window.matchMedia?.('(min-width: 1024px)').matches) return;
  const run = () => {
    for (const a of allowed) if (a !== current) preloadArea(a);
  };
  if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 4000 });
  else setTimeout(run, 2000);
}
